(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.pe-pdp');

  roots.forEach(function (root) {
    initGallery(root);
    initQuantity(root);
    initVariants(root);
    initAddToCart(root);
    initMobileBar(root);
    initCrossSell(root);
    initGiftToggle(root);
    initDescriptionToggle(root);
    initReviewsLink(root);
  });

  function initReviewsLink(root) {
    var link = root.querySelector('[data-pe-reviews-link]');
    var section = root.querySelector('[data-pe-reviews-section]');
    var heading = root.querySelector('[data-pe-reviews-heading]');
    var widget = root.querySelector('.trustpilot-widget');
    if (!link || !section || !widget) return;

    var checked = false;

    // Renvoie : 'pending' (script pas encore passé, on ne sait pas encore),
    // 'content' (de vrais avis affichés) ou 'empty' (script passé, rien à montrer).
    function widgetState() {
      var stillHasFallback = !!widget.querySelector('a[href*="trustpilot.com/review"]');
      if (stillHasFallback) return 'pending';
      var style = window.getComputedStyle(widget);
      var visible = widget.offsetHeight > 20 && style.display !== 'none' && style.visibility !== 'hidden';
      return visible ? 'content' : 'empty';
    }

    function hideEmptyState() {
      link.hidden = true;
      if (heading) heading.hidden = true;
      section.style.minHeight = '0';
    }

    // Le widget Trustpilot ne charge ses données que lorsqu'il devient visible
    // à l'écran, et remplace alors son lien de secours par soit de vrais avis,
    // soit rien du tout (data-no-reviews="hide"). Tant que ce lien de secours
    // est encore présent, le script n'est pas encore passé — on continue
    // d'attendre plutôt que de conclure trop vite sur une fausse hauteur.
    function pollWidget(attemptsLeft) {
      if (checked) return;
      var state = widgetState();
      if (state === 'content') {
        checked = true;
        return;
      }
      if (state === 'empty' || attemptsLeft <= 0) {
        checked = true;
        hideEmptyState();
        return;
      }
      setTimeout(function () { pollWidget(attemptsLeft - 1); }, 500);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !checked) {
            pollWidget(16); // ~8 secondes de sondage max une fois visible
          }
        });
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    } else {
      pollWidget(16);
    }
  }

  function initDescriptionToggle(root) {
    var description = root.querySelector('[data-pe-description]');
    var toggle = root.querySelector('[data-pe-description-toggle]');
    if (!description || !toggle) return;

    function checkClamp() {
      description.classList.remove('is-clamped');
      toggle.classList.remove('is-needed');
      toggle.hidden = true;

      description.classList.add('is-clamped');
      if (description.scrollHeight > description.clientHeight + 2) {
        toggle.hidden = false;
        toggle.classList.add('is-needed');
      } else {
        description.classList.remove('is-clamped');
      }
    }

    toggle.addEventListener('click', function () {
      description.classList.remove('is-clamped');
      toggle.hidden = true;
    });

    checkClamp();
    window.addEventListener('resize', checkClamp);
  }

  function initGiftToggle(root) {
    var toggle = root.querySelector('[data-pe-gift-toggle]');
    var fields = root.querySelector('[data-pe-gift-fields]');
    var textarea = root.querySelector('[data-pe-gift-textarea]');
    if (!toggle || !fields || !textarea) return;

    toggle.addEventListener('change', function () {
      fields.hidden = !toggle.checked;
      textarea.disabled = !toggle.checked;
      if (toggle.checked) textarea.focus();
    });
  }

  function initVariants(root) {
    var script = root.querySelector('[data-pe-variants]');
    var optionInputs = root.querySelectorAll('[data-pe-option-input]');
    if (!script || !optionInputs.length) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var hiddenInput = root.querySelector('[data-pe-variant-id]');
    var priceCurrent = root.querySelector('[data-pe-price-current]');
    var priceCompare = root.querySelector('[data-pe-price-compare]');
    var mobileBarPrice = root.querySelector('[data-pe-mobile-bar] .pe-pdp__mobile-bar-price');
    var ctaButton = root.querySelector('[data-pe-add-to-cart]');
    var ctaLabel = root.querySelector('[data-pe-cta-label]');
    var stockNote = root.querySelector('[data-pe-stock-note]');
    var mainSlides = root.querySelectorAll('.pe-pdp__main-slide');
    var thumbs = root.querySelectorAll('.pe-pdp__thumb');
    var i18n = root.dataset;

    function money(cents) {
      // Repli simple ; le rendu initial (côté serveur) utilise déjà le filtre `money` du thème.
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function currentSelection() {
      var values = [];
      var fieldsets = root.querySelectorAll('.pe-pdp__option');
      fieldsets.forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (checked) values.push(checked.value);
      });
      return values;
    }

    function findVariant(values) {
      return variants.filter(function (variant) {
        return values.every(function (value, index) {
          return variant.options[index] === value;
        });
      })[0];
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (hiddenInput) hiddenInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = money(variant.price);
      if (mobileBarPrice) mobileBarPrice.textContent = money(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = money(variant.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (ctaButton) ctaButton.disabled = !variant.available;
      if (ctaLabel) ctaLabel.textContent = variant.available ? i18n.i18nAddToCart : i18n.i18nSoldOut;
      if (stockNote) {
        stockNote.innerHTML = variant.available
          ? '<span class="pe-pdp__stock-dot" aria-hidden="true"></span> ' + i18n.i18nInStock
          : i18n.i18nOutOfStock;
      }
      if (variant.featured_media && mainSlides.length) {
        var mediaId = String(variant.featured_media.id);
        mainSlides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === mediaId);
        });
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
        });
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applyVariant(findVariant(currentSelection()));
      });
    });
  }

  function initMobileBar(root) {
    var bar = root.querySelector('[data-pe-mobile-bar]');
    var mainCta = root.querySelector('[data-pe-add-to-cart]');
    var mainImage = root.querySelector('.pe-pdp__main-media');
    var trigger = mainImage || mainCta;
    var mobileAdd = root.querySelector('[data-pe-mobile-add]');
    var form = root.querySelector('[data-pe-product-form]');
    if (!bar || !trigger) return;

    bar.hidden = false;

    var ticking = false;
    function updateVisibility() {
      var rect = trigger.getBoundingClientRect();
      var ctaIsAboveViewport = rect.bottom < 0;
      bar.classList.toggle('is-visible', ctaIsAboveViewport);
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();

    mobileAdd && mobileAdd.addEventListener('click', function () {
      if (form && form.requestSubmit) {
        form.requestSubmit();
      } else {
        mainCta.click();
      }
    });
  }

  function initCrossSell(root) {
    var container = root.querySelector('[data-pe-cross-sell]');
    var list = root.querySelector('[data-pe-cross-sell-list]');
    if (!container || !list || !window.fetch) return;

    var productId = container.getAttribute('data-product-id');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function render(products) {
      if (!products || !products.length) return;
      list.innerHTML = products.slice(0, 3).map(function (p) {
        var image = p.featured_image || (p.images && p.images[0]) || '';
        return '<a class="pe-pdp__cross-sell-item" href="' + p.url + '">' +
          (image ? '<img src="' + image + '&width=200" alt="" loading="lazy">' : '') +
          '<span>' + p.title + '</span>' +
          '<span class="pe-pdp__cross-sell-price">' + (p.price / 100).toFixed(2).replace('.', ',') + ' €</span>' +
        '</a>';
      }).join('');
      container.hidden = false;
    }

    fetch(base + 'recommendations/products.json?product_id=' + productId + '&limit=3&intent=complementary')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.products && data.products.length) {
          render(data.products);
        } else {
          return fetch(base + 'recommendations/products.json?product_id=' + productId + '&limit=3&intent=related')
            .then(function (res) { return res.json(); })
            .then(function (data2) { render(data2.products); });
        }
      })
      .catch(function () {});
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-media-id].pe-pdp__thumb, .pe-pdp__thumb');
    var slides = root.querySelectorAll('.pe-pdp__main-slide');
    if (!thumbs.length || !slides.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-pe-qty-input]');
    var dec = root.querySelector('[data-pe-qty-decrease]');
    var inc = root.querySelector('[data-pe-qty-increase]');
    if (!input) return;

    dec && dec.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    inc && inc.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  }

  function initAddToCart(root) {
    var form = root.querySelector('[data-pe-product-form]');
    var button = root.querySelector('[data-pe-add-to-cart]');
    var label = root.querySelector('[data-pe-cta-label]');
    if (!form || !button) return;
    var i18n = root.dataset;

    function handleSubmit(evt) {
      evt.preventDefault();
      var formData = new FormData(form);
      var originalLabel = label ? label.textContent : '';

      button.disabled = true;
      if (label) label.textContent = i18n.i18nAdding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = i18n.i18nAdded;
          button.classList.add('is-added');
          button.disabled = false;
          document.dispatchEvent(new CustomEvent('pe:cart:added'));
          setTimeout(function () {
            if (label) label.textContent = originalLabel;
            button.classList.remove('is-added');
          }, 1800);
        })
        .catch(function (err) {
          // Repli robuste : on retire l'écouteur AJAX et on soumet le formulaire nativement
          // (fonctionne même si l'API JSON du panier est inaccessible : proxy, CSP, etc.)
          if (label) label.textContent = originalLabel;
          button.disabled = false;
          form.removeEventListener('submit', handleSubmit);
          form.submit();
        });
    }

    form.addEventListener('submit', handleSubmit);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
